module.exports = __webpack_public_path__ + "img/20180815_145537_000.4590c913.jpg";